// DurationPicker.js
import React, { useEffect, useState } from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/material';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ValueMisc from '../value/ValueMisc';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';

const PickerContainer = styled(Box)({
    display:'inline-flex', alignItems:'center'
});
const PickerColumn = styled(Box)({
    display:'inline-block', marginRight:10
});

const ThePicker = styled(DateTimePicker)({
    "& .MuiInputBase-input": {padding:"11px 0px 11px 8px", width:115, fontSize:'0.9rem'}
});

export default function DurationPicker({
    from,
    till,
    onChangeFrom,
    onChangeTill,
    labelFrom,
    labelTill,
    tailFrom,
    tailTill,
}) {
    const [defaultFrom, setDefaultFrom] = useState(dayjs(ValueMisc.getYmdHms(new Date(), 5*3600)));
    const [defaultTill, setDefaultTill] = useState(dayjs(new Date()));

    useEffect(()=>{
            if(from) {
                setDefaultFrom(dayjs(from));
            }
            else setDefaultFrom(dayjs(dayjs(ValueMisc.getYmdHms(new Date(), 5*3600))));
    }, [from]);

    useEffect(()=>{
            if(till) {
                setDefaultTill(dayjs(till));
            }
            else setDefaultTill(dayjs(new Date()));
    }, [till]);

    const onChangeFromTime = (value, ctxt) => {
        if(onChangeFrom)
            onChangeFrom(ValueMisc.getYmdHms(value.toDate()));
    };

    const onChangeTillTime = (value, ctxt) => {
        if(onChangeTill)
            onChangeTill(ValueMisc.getYmdHms(value.toDate()));
    };

    return (
        <PickerContainer>
            <PickerColumn>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                    <ThePicker ampm={false} format='YYYY-MM-DD HH:mm'
                        onChange={onChangeFromTime}
                        value={defaultFrom || ''}
                        label={labelFrom}
                    />
                </LocalizationProvider>

            </PickerColumn>
                <span style={{maringLeft:10, marginRight:20}}>
                    {tailFrom || '부터'}
                </span>
            <PickerColumn>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                    <ThePicker ampm={false} format='YYYY-MM-DD HH:mm'
                        onChange={onChangeTillTime}
                        value={defaultTill || ''}
                        label={labelTill}
                    />
                </LocalizationProvider>

            </PickerColumn>
                <span style={{maringLeft:10}}>
                    {tailTill || '까지'}
                </span>

        </PickerContainer>
    );
}